import { useState, useEffect } from 'react'
import { Menu, MenuItem, Button, Box, Typography } from '@mui/material'
import en from '../assets/english.webp'
import ar from '../assets/arabic.png'
import { useTranslation } from 'react-i18next'

const languages = [
  { code: 'en', name: 'English', flag: en },
  { code: 'ar', name: 'Arabic', flag: ar },
]

export default function LanguageDropdown() {
  const [anchorEl, setAnchorEl] = useState(null)
  const [selectedLang, setSelectedLang] = useState(languages[0])
  const { i18n } = useTranslation()

  // Load saved language from localStorage on component mount
  useEffect(() => {
    const savedLangCode = localStorage.getItem('selectedLang')
    if (savedLangCode) {
      const savedLang = languages.find((lang) => lang.code === savedLangCode)
      if (savedLang) {
        setSelectedLang(savedLang)
        i18n.changeLanguage(savedLang.code)
      }
    }
  }, [i18n])

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng)
  }

  const handleClose = (lang) => {
    if (lang) {
      setSelectedLang(lang)
      changeLanguage(lang.code)
      localStorage.setItem('selectedLang', lang.code) // Save selected language to localStorage
    }
    setAnchorEl(null)
  }

  return (
    <Box
      sx={{
        display: 'inline-block',
        zIndex: 3,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* Dropdown Button */}
      <Button
        onClick={handleClick}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '60px',
          minWidth: '50px',
          textTransform: 'none',
          mb: 4,
          bgcolor: 'transparent',
          padding: '10px',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <img
            src={selectedLang.flag}
            alt={selectedLang.name}
            style={{ width: '24px', height: '24px' }}
          />
        </Box>
      </Button>

      {/* Dropdown Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleClose(null)}
        slotProps={{
          paper: {
            sx: {
              width: '200px',
              bgcolor: '#fff',
              color: '#000',
              borderRadius: 5,
              boxShadow: '0px 4px 10px rgba(0,0,0,0.2)',
            },
          },
        }}
      >
        {languages.map((lang) => (
          <MenuItem
            key={lang.code}
            onClick={() => handleClose(lang)}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              '&:hover': { bgcolor: 'primary.main' },
            }}
          >
            <img
              src={lang.flag}
              alt={lang.name}
              style={{ width: '24px', height: '24px' }}
            />
            <Typography>{lang.name}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  )
}
